var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 114.4 116",
    style: {
      enableBackground: "new 0 0 114.4 116"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:currentColor;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.6,19.7C85.5,9.4,72.1,3.8,57.8,3.8S30.2,9.4,20.1,19.7C10,29.9,4.5,43.5,4.5,58S10,86.1,20.1,96.4 c10.1,10.3,23.5,15.9,37.7,15.9s27.7-5.6,37.7-15.9c3.5-3.6,6.6-7.7,9-12.2l0.4-0.7l-2.8-5L65.5,11.8c9.4,1.6,18.1,6.2,24.9,13.1 c8.7,8.8,13.5,20.6,13.5,33.1c0,3.6-0.4,7.3-1.2,10.8l-0.1,0.6l5,9l1.1-3.3c1.8-5.5,2.7-11.2,2.7-17 C111.2,43.5,105.6,29.9,95.6,19.7z M57.8,104.8c-12.3,0-23.8-4.9-32.5-13.7c-1.9-1.9-3.6-4-5.1-6.2l45.5,0l12.6,0l0,0h0l-1.1-2.2 L49.3,34.2l9.2-16.6l37.3,66.8c-1.6,2.4-3.5,4.7-5.5,6.8C81.7,100,70.1,104.8,57.8,104.8z M42,59.4l-4.7,8.4h21.9l4.9,8.7H28.2 l16-28.9L39.4,39L17,79.5c-3.4-6.6-5.1-14-5.1-21.5c0-12.5,4.8-24.3,13.5-33.1c8.2-8.3,16.2-12.8,27.7-13.4L40.3,34.6L54,58.7 l0.4,0.7H42z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e7448ac87e3ba6d8864025d5773fbd7b.svg";
export { ForwardRef as ReactComponent };